import { z } from 'zod';
import { email } from './common.js';
import { CustomerType } from '../types/enums.js';
export const createCustomerSchema = z.object({
    name: z.string().min(1).max(200),
    type: z.nativeEnum(CustomerType),
    sector: z.string().nullable().optional(),
    address: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    email: z.union([email, z.literal('')]).nullable().optional(),
    dept: z.array(z.string()).default([]),
});
export const updateCustomerSchema = createCustomerSchema.partial();
export const customerQuerySchema = z.object({
    search: z.string().optional(),
    type: z.nativeEnum(CustomerType).optional(),
    sector: z.string().optional(),
});
//# sourceMappingURL=customer.js.map